import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { useMarket } from "#/contexts/MarketContext";
import {
  useGetScansToProcess,
  useGetOrdersWithoutScans,
  useGetScansWithoutOrders,
} from "#/lib/api/scan-control";
import { ScanControlPage } from "#/components/pages/scan-control/scan-control-page";
import type { ScanWithoutOrderRow } from "#/components/organisms/scan-control/types";

export const Route = createFileRoute("/$tenantCode/$market/scan-control")({
  beforeLoad: () => ({ getTitle: () => m["resources.scanControl.name"]() }),
  component: ScanControlRoute,
});

function ScanControlRoute() {
  const market = useMarket();

  const { data: scansData, isLoading: isScansLoading } = useGetScansToProcess();
  const { data: ordersData, isLoading: isOrdersLoading } =
    useGetOrdersWithoutScans(market);
  const { data: orphansData, isLoading: isOrphansLoading } =
    useGetScansWithoutOrders();

  return (
    <ScanControlPage
      scansToProcess={scansData?.member ?? []}
      ordersWithoutScans={ordersData?.member ?? []}
      scansWithoutOrders={
        (orphansData?.member ?? []) as unknown as ScanWithoutOrderRow[]
      }
      isLoading={isScansLoading || isOrdersLoading || isOrphansLoading}
    />
  );
}
